import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#FAF8F5]/95 backdrop-blur-xl border-b border-[#E5E0D5] shadow-sm'
          : 'bg-transparent'
      }`}
      data-testid="main-navigation"
    >
      <div className="px-6 md:px-12 lg:px-24 max-w-7xl mx-auto">
        <div className="flex items-center justify-between h-20 md:h-24">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3"
            data-testid="logo-button"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_royal-inox/artifacts/ypcsq30z_ChatGPT%20Image%20Apr%2021%2C%202026%2C%2002_31_59%20PM.png"
              alt="ROY.INOX Logo"
              className="h-[72px] md:h-20 w-auto"
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-10">
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#2D3436] hover:text-[#2C6E63]' : 'text-white hover:text-white/70'
              }`}
              data-testid="nav-about"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#2D3436] hover:text-[#2C6E63]' : 'text-white hover:text-white/70'
              }`}
              data-testid="nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#2D3436] hover:text-[#2C6E63]' : 'text-white hover:text-white/70'
              }`}
              data-testid="nav-partners"
            >
              Partners
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#2D3436] hover:text-[#2C6E63]' : 'text-white hover:text-white/70'
              }`}
              data-testid="nav-portfolio"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('gallery')}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 ${
                isScrolled ? 'text-[#2D3436] hover:text-[#2C6E63]' : 'text-white hover:text-white/70'
              }`}
              data-testid="nav-gallery"
            >
              Gallery
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="px-8 py-3 bg-[#2C6E63] text-white text-sm font-medium tracking-wide hover:bg-[#1A535C] transition-all duration-300"
              data-testid="nav-contact-cta"
            >
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden p-2 ${isScrolled ? 'text-[#2D3436]' : 'text-white'}`}
            data-testid="mobile-menu-button"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          className="md:hidden bg-[#FAF8F5] border-t border-[#E5E0D5]"
          data-testid="mobile-menu"
        >
          <div className="px-6 py-6 space-y-4">
            <button
              onClick={() => scrollToSection('about')}
              className="block w-full text-left text-base font-medium text-[#2D3436] hover:text-[#2C6E63] transition-colors"
              data-testid="mobile-nav-about"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="block w-full text-left text-base font-medium text-[#2D3436] hover:text-[#2C6E63] transition-colors"
              data-testid="mobile-nav-services"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="block w-full text-left text-base font-medium text-[#2D3436] hover:text-[#2C6E63] transition-colors"
              data-testid="mobile-nav-partners"
            >
              Partners
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="block w-full text-left text-base font-medium text-[#2D3436] hover:text-[#2C6E63] transition-colors"
              data-testid="mobile-nav-portfolio"
            >
              Portfolio
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="block w-full px-6 py-3 bg-[#2C6E63] text-white text-base font-medium hover:bg-[#1A535C] transition-colors"
              data-testid="mobile-nav-contact-cta"
            >
              Contact
            </button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
